import { useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router";
import WishlistSelectModeBanner from "../../../../Components/Banners/WishlistSelectModeBanner";
import SelectModeSubbarOpener from "../../../../Components/Banners/SelectModeBanner/opener";
import DashboardLayout, { FilterContext } from "../../../../Layouts/Dashboard/dashboard";
import { routePaths } from "../../../../Router/router";
import { ObjectLayer } from "../../../../Core/Api/Types/object-layer";
import { cacheService } from "../../../../Core/Api/services";
import ShareBanner from "../../../../Components/Banners/ShareBanner";
import { DbShareMediaInfos } from "../../../../Core/Api/Types/db-share-media-infos";
import { MetadataFieldValueObjectTypes } from "../../../../Core/Api/Types/metadata-field-value-object-types";
import FiltersPanel from "../../../../Components/Filters/FiltersPanel/filters-panel";
import { DbMetadataFieldInfos } from "../../../../Core/Api/Types/db-metadata-field-infos";
import { DbAssetObjectInfos } from "../../../../Core/Api/Types/db-asset-object-infos";
import { PlatformMode } from "../../../../Core/Api/Types/platform-mode";
import { Stack } from "@mui/system";

function Inventory() {
    /*
  Note: Selection of shares has been let here just in case since we moved the Shares to the main menu left with his own shares-index.tsx!
  */

    const [selectedItems, setSelectedItems] = useState<DbAssetObjectInfos[]>([]);
    const [selectedShares, setSelectedShares] = useState<DbShareMediaInfos[]>([]);
    const [reload, setReload] = useState<number>(0);

    const handleCloseClick = () => {
        setSelectedItems([]);
        setSelectedShares([]);
    };

    const { pathname } = useLocation();

    const layer = pathname === routePaths.inventory.path ? ObjectLayer.Title : ObjectLayer.Asset;
    const mode = cacheService.GetPlatformMode();
    const location = useLocation();
    const curPath = location.pathname.toString();

    // Use no max width for order items due to large data amount
    let isShares = curPath === routePaths.shares.path;
    let isAdam = mode === PlatformMode.Adam;
    let finalMaxWidth = isShares || isAdam ? false : undefined;

    const [openSidebar, setOpenSidebar] = useState(true);
    const [openFiltersPanel, setOpenFiltersPanel] = useState(false);
    const [openFiltersPanelLayer, setOpenFiltersPanelLayer] = useState<ObjectLayer | null>(ObjectLayer.Title);
    const [openFiltersPanelType, setOpenFiltersPanelType] = useState(MetadataFieldValueObjectTypes.DbAssetObjectInfos);
    const [openFiltersPanelMetadataFields, setOpenFiltersPanelMetadataFields] = useState<
        DbMetadataFieldInfos[] | undefined
    >(undefined);
    // Todo avoid load users in each page change
    const filterPanel = useMemo(() => {
        return (
            <FiltersPanel
                openSidebar={openSidebar}
                layer={openFiltersPanelLayer}
                type={openFiltersPanelType}
                metadataFieldsOverride={openFiltersPanelMetadataFields}
            />
        );
    }, [openSidebar, openFiltersPanelLayer, openFiltersPanelType, openFiltersPanelMetadataFields]);

    return (
        <FilterContext.Provider
            value={{
                setOpenFiltersPanel,
                setOpenFiltersPanelLayer,
                setOpenFiltersPanelType,
                setOpenFiltersPanelMetadataFields,
                openFiltersPanel,
                openFiltersPanelLayer,
                openFiltersPanelType,
                openFiltersPanelMetadataFields,
            }}
        >
            {filterPanel}
            <DashboardLayout
                maxWidth={finalMaxWidth}
                setOpenSidebarFallback={setOpenSidebar}
                sxContent={{ px: 2 }}
                Banner={
                    !isShares ? (
                        <WishlistSelectModeBanner
                            items={selectedItems}
                            setItems={setSelectedItems}
                            handleCloseClick={handleCloseClick}
                            layer={layer}
                            itemsCanBeShared={false}
                            setReload={setReload}
                        />
                    ) : (
                        <ShareBanner shares={selectedShares} handleCloseClick={handleCloseClick} />
                    )
                }
            >
                <Outlet
                    context={{
                        selectedItems: selectedItems,
                        setSelectedItems: setSelectedItems,
                        selectedShares: selectedShares,
                        setSelectedShares: setSelectedShares,
                        reload: reload,
                        setReload: setReload,
                    }}
                />
                <SelectModeSubbarOpener selectedObjects={!isShares ? selectedItems : selectedShares.map((s) => s.id)} />
            </DashboardLayout>
        </FilterContext.Provider>
    );
}

export default Inventory;
